import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SuggestionsDirective } from '@lib/ui';
import { ConfigurableDialog, DialogModule, DialogService } from '@proget-shared/dialog';
import { ApiErrorsModule } from '@proget-shared/form/api-errors';
import { CustomValidators } from '@proget-shared/form/custom-validators';
import { FormControlErrorModule } from '@proget-shared/form/form-control-error';
import { FormHelperModule } from '@proget-shared/form/helper';
import { WysiwygComponent } from '@proget-shared/form/wysiwyg';
import { ResponseErrorForm, ResponseErrorTemplateMapper } from '@proget-shared/helper/response-error';
import { TranslateModule } from '@proget-shared/translate';
import { ToastService } from '@proget-shared/ui/toast';

import { User } from '../../model';
import { UserCardRepository } from '../../user-card.repository';

@Component({
  selector: 'lib-mail-form-dialog',
  templateUrl: './mail-form-dialog.component.html',
  styleUrls: ['./mail-form-dialog.component.scss'],
  imports: [
    ReactiveFormsModule,
    DialogModule,
    WysiwygComponent,
    ApiErrorsModule,
    SuggestionsDirective,
    FormControlErrorModule,
    FormHelperModule,
    TranslateModule,
  ],
})
export class MailFormDialogComponent implements ConfigurableDialog {
  protected readonly form: FormGroup;

  protected errors: ResponseErrorForm = {};

  private readonly dialog = inject(DialogService);
  private readonly toastService = inject(ToastService);
  private readonly userCardRepository = inject(UserCardRepository);

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group({
      uuid: [null, [Validators.required]],
      message: ['', [CustomValidators.htmlContentRequired]],
    });
  }

  onConfiguration(configuration: { user: User }): void {
    this.form.patchValue({
      uuid: configuration.user.uuid,
    });
  }

  protected close(): void {
    this.dialog.reject(this);
  }

  protected submit({ valid, value }: FormGroup): void {
    if (!valid) {
      return;
    }

    this.userCardRepository.sendMail(value.uuid, value.message)
      .subscribe({
        next: () => {
          this.dialog.resolve(this);
        },
        error: (errors) => {
          this.toastService.error(
            'library.user_card.toast.send_email.error',
            ResponseErrorTemplateMapper.map(errors.message)
          );
          this.errors = errors.form;
        },
      });
  }
}
